import { render, staticRenderFns } from "./tip1.vue?vue&type=template&id=0c0287f5&scoped=true"
import script from "./tip1.vue?vue&type=script&lang=js"
export * from "./tip1.vue?vue&type=script&lang=js"
import style0 from "./tip1.vue?vue&type=style&index=0&id=0c0287f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0287f5",
  null
  
)

export default component.exports